import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ConditionSerializer2v4zqxahhdocs as ConditionSerializer } from './ConditionSerialization.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Never_getInstance3of1faxayn0qw as Never_getInstance } from './Condition.mjs';
import {
  $serializer3h4o01siqyg1z as $serializer,
  Mask37ta2qlh32220 as Mask,
} from './Mask.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  $serializer3begl8eud4mug as $serializer_0,
  UpdateRestrictions32h9nfoepzv9j as UpdateRestrictions,
} from './UpdateRestrictions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { LongSerializer_getInstancepwtz4tlewrfw as LongSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.ModelPermissions', null, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('create', true);
        tmp0_serialDesc.addElement_5pzumi_k$('read', true);
        tmp0_serialDesc.addElement_5pzumi_k$('readMask', true);
        tmp0_serialDesc.addElement_5pzumi_k$('update', true);
        tmp0_serialDesc.addElement_5pzumi_k$('updateRestrictions', true);
        tmp0_serialDesc.addElement_5pzumi_k$('delete', true);
        tmp0_serialDesc.addElement_5pzumi_k$('maxQueryTimeMs', true);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_nrleg8_k$(typeSerial0) {
        return $serializer_1().new_com_lightningkite_services_database_ModelPermissions_$serializer_hc1xla_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_nrleg8_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer_1() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_ModelPermissions_$serializer_noqu3h_k$();
      }
      static new_com_lightningkite_services_database_ModelPermissions_$serializer_noqu3h_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.ModelPermissions', $this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('create', true);
        tmp0_serialDesc.addElement_5pzumi_k$('read', true);
        tmp0_serialDesc.addElement_5pzumi_k$('readMask', true);
        tmp0_serialDesc.addElement_5pzumi_k$('update', true);
        tmp0_serialDesc.addElement_5pzumi_k$('updateRestrictions', true);
        tmp0_serialDesc.addElement_5pzumi_k$('delete', true);
        tmp0_serialDesc.addElement_5pzumi_k$('maxQueryTimeMs', true);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_lwn2ga_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !value.create_1.equals(Never_getInstance())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, new (ConditionSerializer())(this.typeSerial0__1), value.create_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !value.read_1.equals(Never_getInstance())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), value.read_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !value.readMask_1.equals(new (Mask())(emptyList()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer().new_com_lightningkite_services_database_Mask_$serializer_me4g3t_k$(this.typeSerial0__1), value.readMask_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !value.update_1.equals(Never_getInstance())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, new (ConditionSerializer())(this.typeSerial0__1), value.update_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !value.updateRestrictions_1.equals(new (UpdateRestrictions())(VOID, emptyList()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, $serializer_0().new_com_lightningkite_services_database_UpdateRestrictions_$serializer_1z5rxp_k$(this.typeSerial0__1), value.updateRestrictions_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !value.delete_1.equals(Never_getInstance())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, new (ConditionSerializer())(this.typeSerial0__1), value.delete_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.maxQueryTimeMs_1 === 1000n)) {
          tmp1_output.encodeLongElement_ovnxxh_k$(tmp0_desc, 6, value.maxQueryTimeMs_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_lwn2ga_k$(encoder, value instanceof ModelPermissions() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = 0n;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (ConditionSerializer())(this.typeSerial0__1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer().new_com_lightningkite_services_database_Mask_$serializer_me4g3t_k$(this.typeSerial0__1), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, new (ConditionSerializer())(this.typeSerial0__1), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, $serializer_0().new_com_lightningkite_services_database_UpdateRestrictions_$serializer_1z5rxp_k$(this.typeSerial0__1), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, new (ConditionSerializer())(this.typeSerial0__1), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeLongElement_994anb_k$(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (ConditionSerializer())(this.typeSerial0__1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer().new_com_lightningkite_services_database_Mask_$serializer_me4g3t_k$(this.typeSerial0__1), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, new (ConditionSerializer())(this.typeSerial0__1), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, $serializer_0().new_com_lightningkite_services_database_UpdateRestrictions_$serializer_1z5rxp_k$(this.typeSerial0__1), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, new (ConditionSerializer())(this.typeSerial0__1), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeLongElement_994anb_k$(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ModelPermissions().new_com_lightningkite_services_database_ModelPermissions_jqheas_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ConditionSerializer())(this.typeSerial0__1), new (ConditionSerializer())(this.typeSerial0__1), $serializer().new_com_lightningkite_services_database_Mask_$serializer_me4g3t_k$(this.typeSerial0__1), new (ConditionSerializer())(this.typeSerial0__1), $serializer_0().new_com_lightningkite_services_database_UpdateRestrictions_$serializer_1z5rxp_k$(this.typeSerial0__1), new (ConditionSerializer())(this.typeSerial0__1), LongSerializer_getInstance()];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_services_database_ModelPermissions_$serializer_hc1xla_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_services_database_ModelPermissions_$serializer_noqu3h_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var ModelPermissionsClass;
function ModelPermissions() {
  if (ModelPermissionsClass === VOID) {
    class $ {
      constructor(create, read, readMask, update, updateRestrictions, delete_0, maxQueryTimeMs) {
        Companion_getInstance();
        create = create === VOID ? Never_getInstance() : create;
        read = read === VOID ? Never_getInstance() : read;
        readMask = readMask === VOID ? new (Mask())(emptyList()) : readMask;
        update = update === VOID ? Never_getInstance() : update;
        updateRestrictions = updateRestrictions === VOID ? new (UpdateRestrictions())(VOID, emptyList()) : updateRestrictions;
        delete_0 = delete_0 === VOID ? Never_getInstance() : delete_0;
        maxQueryTimeMs = maxQueryTimeMs === VOID ? 1000n : maxQueryTimeMs;
        this.create_1 = create;
        this.read_1 = read;
        this.readMask_1 = readMask;
        this.update_1 = update;
        this.updateRestrictions_1 = updateRestrictions;
        this.delete_1 = delete_0;
        this.maxQueryTimeMs_1 = maxQueryTimeMs;
      }
      toString() {
        return 'ModelPermissions(create=' + toString(this.create_1) + ', read=' + toString(this.read_1) + ', readMask=' + this.readMask_1.toString() + ', update=' + toString(this.update_1) + ', updateRestrictions=' + this.updateRestrictions_1.toString() + ', delete=' + toString(this.delete_1) + ', maxQueryTimeMs=' + this.maxQueryTimeMs_1.toString() + ')';
      }
      hashCode() {
        var result = this.create_1.hashCode();
        result = imul(result, 31) + this.read_1.hashCode() | 0;
        result = imul(result, 31) + this.readMask_1.hashCode() | 0;
        result = imul(result, 31) + this.update_1.hashCode() | 0;
        result = imul(result, 31) + this.updateRestrictions_1.hashCode() | 0;
        result = imul(result, 31) + this.delete_1.hashCode() | 0;
        result = imul(result, 31) + getBigIntHashCode(this.maxQueryTimeMs_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ModelPermissions()))
          return false;
        if (!this.create_1.equals(other.create_1))
          return false;
        if (!this.read_1.equals(other.read_1))
          return false;
        if (!this.readMask_1.equals(other.readMask_1))
          return false;
        if (!this.update_1.equals(other.update_1))
          return false;
        if (!this.updateRestrictions_1.equals(other.updateRestrictions_1))
          return false;
        if (!this.delete_1.equals(other.delete_1))
          return false;
        if (!(this.maxQueryTimeMs_1 === other.maxQueryTimeMs_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_ModelPermissions_jqheas_k$(seen0, create, read, readMask, update, updateRestrictions, delete_0, maxQueryTimeMs, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, Companion_getInstance().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.create_1 = Never_getInstance();
        else
          $this.create_1 = create;
        if (0 === (seen0 & 2))
          $this.read_1 = Never_getInstance();
        else
          $this.read_1 = read;
        if (0 === (seen0 & 4))
          $this.readMask_1 = new (Mask())(emptyList());
        else
          $this.readMask_1 = readMask;
        if (0 === (seen0 & 8))
          $this.update_1 = Never_getInstance();
        else
          $this.update_1 = update;
        if (0 === (seen0 & 16))
          $this.updateRestrictions_1 = new (UpdateRestrictions())(VOID, emptyList());
        else
          $this.updateRestrictions_1 = updateRestrictions;
        if (0 === (seen0 & 32))
          $this.delete_1 = Never_getInstance();
        else
          $this.delete_1 = delete_0;
        if (0 === (seen0 & 64))
          $this.maxQueryTimeMs_1 = 1000n;
        else
          $this.maxQueryTimeMs_1 = maxQueryTimeMs;
        return $this;
      }
    }
    initMetadataForClass($, 'ModelPermissions', ModelPermissions, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    ModelPermissionsClass = $;
  }
  return ModelPermissionsClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance2v6degzrm2jsl,
};
//endregion

//# sourceMappingURL=ModelPermissions.mjs.map
